import {
  AUTH_REGISTER_REQUEST,
  AUTH_REGISTER_SUCCESS,
  AUTH_REGISTER_FAIL,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAIL,
  AUTH_LOGOUT_REQUEST,
  AUTH_GET_PROFILE_REQUEST,
  AUTH_GET_PROFILE_SUCCESS,
  AUTH_GET_PROFILE_FAIL,
  AUTH_FORGOT_PASSWORD_SUCCESS,
  AUTH_FORGOT_PASSWORD_FAIL,
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_CLEAR_MSG,
  AUTH_RESET_PASSWORD_REQUEST,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAIL
} from "../actions/auth";

const initialState = {
  loading: false,
  errorMsg: "",
  successMsg: "",
  errors: {},
  email: "",
  password: "",
  profile: {},
  resetPasswordRequest: false
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_REGISTER_REQUEST:
      return {
        ...state,
        loading: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case AUTH_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        profile: action.profile
      };
    case AUTH_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        errorMsg: action.msg,
        errors: action.errors,
        successMsg: ""
      };
    case AUTH_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        errorMsg: "",
        successMsg: "",
        errors: {}
      };
    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        errorMsg: "",
        successMsg: action.msg,
        errors: {},
        profile: action.profile
      };
    case AUTH_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        errorMsg: action.msg,
        errors: action.errors,
        successMsg: ""
      };
    case AUTH_LOGOUT_REQUEST:
      return {
        ...state,
        loading: false,
        profile: {}
      };
    case AUTH_GET_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        successMsg: "",
        errorMsg: "",
        errors: {}
      };
    case AUTH_GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.msg,
        errorMsg: "",
        errors: {},
        profile: action.profile
      };
    case AUTH_GET_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        successMsg: "",
        errorMsg: action.msg,
        errors: action.errors,
        profile: {}
      };
    case AUTH_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordRequest: true,
        forgotPasswordSuccessMsg: null,
        forgotPasswordErrorMsg: null,
        forgotPasswordErrors: null,
      };
    case AUTH_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordRequest: false,
        forgotPasswordSuccessMsg: action.msg,
        forgotPasswordErrorMsg: null,
        forgotPasswordErrors: null,
      };
    case AUTH_FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        forgotPasswordRequest: false,
        forgotPasswordSuccessMsg: null,
        forgotPasswordErrorMsg: action.msg,
        forgotPasswordErrors: action.errors,
      };
    case AUTH_CLEAR_MSG:
      return {
        ...state,
        successMsg: "",
        errorMsg: "",
        errors: {}
      };
    case AUTH_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordRequest: true,
        resetPasswordSuccessMsg: null,
        resetPasswordErrorMsg: null,
        resetPasswordErrors: null
      };
    case AUTH_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordRequest: false,
        resetPasswordSuccessMsg: action.msg,
        resetPasswordErrorMsg: null,
        resetPasswordErrors: null
      };
    case AUTH_RESET_PASSWORD_FAIL:
      return {
        ...state,
        resetPasswordRequest: false,
        resetPasswordSuccessMsg: null,
        resetPasswordErrorMsg: action.msg,
        resetPasswordErrors: action.errors
      };
    default:
      return state;
  }
};

export default auth;